import { ArrowTooltip } from '@/components/arrow-tooltip.js';
import { StudentInGroup } from '@airreading/common/data';
import { CircleAlert } from 'lucide-react';
import { ReactNode } from 'react';

export function LevelChangeWarning(person: { id: string }): ReactNode {
  const warning = (person as StudentInGroup).levelChangeWarning;

  if (!warning) {
    return null;
  }

  return (
    <ArrowTooltip
      trigger={
        <CircleAlert
          className="h-[22px] w-[22px] fill-orange-600 stroke-white shrink-0 bg-transparent m-0"
          strokeWidth={3}
        />
      }
      position="bottom"
    >
      <div className="space-y-1 text-sm max-w-[350px] text-left">
        <div>
          {warning.learningPathName
            ? `${warning.learningPathName} ${warning.startingLessonName}`
            : warning.startingLessonName}
        </div>
        {warning.note && <div>{warning.note}</div>}
      </div>
    </ArrowTooltip>
  );
}
